import React, { useState } from "react";
import { Platform, TouchableOpacity } from "react-native";
import { Icon, Panel, Text } from "@clearabee/ui-library-native";
import { useBasket } from "@clearabee/ui-sdk";
import { Spinner } from "components/Core/Spinner/Spinner";
import { ids, styles } from "./DisplayCoupon.styles";

interface DisplayCouponProps {
  coupon: string;
}

const isWeb = Platform.OS === "web";

export const DisplayCoupon = ({
  coupon,
}: DisplayCouponProps): React.ReactElement => {
  const { update } = useBasket();
  const [isLoading, setLoading] = useState(false);

  const handleRemove = async () => {
    setLoading(true);

    try {
      await update.mutateAsync({ coupon: null });
    } catch (error) {}

    setLoading(false);
  };

  return (
    <Panel
      shadow={false}
      color="light"
      styles={styles.panel}
      dataSet={{ ids: ids.panel }}
    >
      <Text fontSize="small">
        Coupon{" "}
        <Text
          fontSize="small"
          style={{
            fontWeight: "bold",
          }}
        >
          {coupon}
        </Text>{" "}
        is applied
      </Text>
      {isLoading && <Spinner />}
      {!isLoading && (
        <TouchableOpacity
          style={styles.removeCoupon}
          dataSet={{ ids: ids.removeCoupon }}
          disabled={isLoading}
          onPress={handleRemove}
        >
          <Icon.Close width={10} height={10} color={isWeb ? "light" : "dark"} />
        </TouchableOpacity>
      )}
    </Panel>
  );
};
